//This script manages product swatch selection, ensuring only one swatch is active at a time. It updates the active swatch dynamically based on user selection and sets the corresponding variant ID in a hidden input field.
document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(".product_swatches");
    if (!container) return;

    const labels = container.querySelectorAll(".swatch__label");
    const swatches = container.querySelectorAll(".swatch__wrapper a");
    const productForm = document.querySelector('[data-type="add-to-cart-form"]');
    const variantInput = productForm?.querySelector('input[name="id"].product-variant-id');

    if (labels.length && swatches.length) {
        labels.forEach((label) => {
            label.addEventListener("click", () => {
                showSwatches(label);
            });
        });

        setTimeout(visibleSwatches, 0);
    }

    function showSwatches(label) {
        const labelAttr = label.getAttribute("data-label");

        labels.forEach((label) => label.classList.remove("active"));
        label.classList.add("active");

        if (labelAttr === "all") {
            swatches.forEach((swatch) => swatch.classList.remove("hide-swatch"));

            // Find the button with loop-index="1" and add the active class
            const targetButton = container.querySelector('.color__swatch[loop-index="1"]');
            console.log(targetButton, "active");

            if (targetButton) {
                // Remove active class from all buttons
                swatches.forEach((swatch) => {
                    const colorSwatch = swatch.querySelector(".color__swatch");
                    if (colorSwatch) {
                        colorSwatch.classList.remove("active");
                    }
                });

                // Add active class to the target button
                targetButton.classList.add("active");

                // Update the variant input with the target button's variant ID
                const variantId = targetButton.getAttribute("data-variant-id");
                if (variantInput) {
                    variantInput.value = variantId;
                }
            }

            // Skip updateActiveSwatch(true) for the "all" label
            visibleSwatches();
        } else {
            swatches.forEach((swatch) => {
                const swatchLabel = swatch.getAttribute("data-label");
                let swatchLabelArr = (swatch.dataset.metafield || "").split(" | ");
                // console.log(swatchLabelArr, labelAttr);
                
                swatch.classList.toggle("hide-swatch", !swatchLabelArr.find((label) => label.trim().toLowerCase() === labelAttr.trim().toLowerCase()));
                swatch.classList.toggle("visible-swatch", !!swatchLabelArr.find((label) => label.trim().toLowerCase() === labelAttr.trim().toLowerCase()));
            });

            // Call updateActiveSwatch for non-"all" labels
            updateActiveSwatch(true);
            visibleSwatches();
        }
    }

    function updateActiveSwatch(removeExisting = false) {
        if (removeExisting) {
            swatches.forEach((swatch) => {
                const colorSwatch = swatch.querySelector(".color__swatch");
                if (colorSwatch) {
                    colorSwatch.classList.remove("active");
                }
            });
        }

        const firstVisibleSwatch = document.querySelector(".swatch__wrapper a.visible-swatch");


        if (firstVisibleSwatch) {
            const firstColorSwatch = firstVisibleSwatch.querySelector(".color__swatch");
            if (firstColorSwatch) {
                firstColorSwatch.classList.add("active");

                const variantId = firstColorSwatch.getAttribute("data-variant-id");
                if (variantInput) {
                    variantInput.value = variantId;
                }
            }
        }
    }

    function toggleActive(swatch) {
        const active = window.location.href === swatch.href;
        const colorSwatch = swatch.querySelector(".color__swatch");
        if (colorSwatch) {
            colorSwatch.classList.toggle("active", active);
        }
    }

    function visibleSwatches() {
        const visibleSwatches = container.querySelectorAll(".swatch__wrapper a.visible-swatch");

        visibleSwatches.forEach((visibleSwatch) => {
            const activeSwatch = visibleSwatch.querySelector(".color__swatch.active");

            if (activeSwatch) {
                const variantId = activeSwatch.getAttribute("data-variant-id");
                if (variantInput) {
                    variantInput.value = variantId;
                }
            }
        });
    }

    if (swatches.length > 0) {
        swatches.forEach((swatch) => toggleActive(swatch));
        updateActiveSwatch(false);
    }
});
